module.exports = __webpack_public_path__ + "img/00008.7189a395.webp";